import styles from "./LoginViaFinger.module.scss";

import FingerIcon from "../../../styles/icon/fingerprint1.svg";
export default function LoginViaFinger({ visibility }) {
  return (
    <>
      <div className={styles.container}></div>
      <div className={styles.fingerprint_container}>
        <div className={styles.title_fingerprint}>تائید اثر انگشت</div>
        <div className={styles.pic_fingerprint}>
          <img src={FingerIcon} alt="fingerprint" />
        </div>
        <div className={styles.cancel} onClick={() => visibility(false)}>
          Cancel
        </div>
      </div>
    </>
  );
}
